//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import * as Actions from "./actions"
import { useCurrentGameSession } from 'store/game_session/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { handleListClassGameActivity } from "./thunks"
import { useCurrentUser } from 'store/users/selectors';
import useSocketForSend from 'components/hooks/useSocketForSend';

const selectore = (state) => {
    return state.games
};

const player_selecter = (state) => state.playGameModal
export const usePlayModal = () => {
    const playGameModal = useSelector(player_selecter, shallowEqual)
    const dispatch = useDispatch();

    const closePlayerModal = () => {
        dispatch(Actions.setPlayGameModal({
            open: false,
            data: {}
        }))
    }
    const openPlayerModal = (data) =>{
        dispatch(Actions.setPlayGameModal({
            open: true,
            data: data
        }))
    }
    return { closePlayerModal, playGameModal , openPlayerModal }
}
const oneGameModal_selecter = (state) => state.oneGameModal
export const useOneGameModal = () => {
    const oneGameModal = useSelector(oneGameModal_selecter, shallowEqual)
    const { currentGameSession } = useCurrentGameSession()
    const dispatch = useDispatch();
    const currentClass = useCurrentClass();
    const currentUser = useCurrentUser();
    const { sendDataOnSocket}  = useSocketForSend();

    const stopNotification1game = () => {
      let notifydata = {
        userId: currentUser.id,
        classId: currentClass.id,
        game_data: {},
        session_id: currentGameSession?.session_id,
        session_code: "",
        code: "stop_game_notification",
      };
      sendDataOnSocket(notifydata);
    };

    const closeOnegamerModal = (currentGameSession) => {
        stopNotification1game(currentGameSession);
        // if (currentGameSession.session_id && currentGameSession.status !== "ended") {
        //     dispatch(handleUpdateCurrentGameSessionStatus(currentGameSession.session_id, "ended"))
        // }
        dispatch(Actions.setOpenOneGame({
            open: false,
            iframeUrl: ''
        }))
    }
    const closeCurrentGameSession = () => {
        dispatch(Actions.setOpenOneGame({
            open: false,
            iframeUrl: ''
        }))
    }
    const openOnegameModal = (url) => {
        dispatch(Actions.setOpenOneGame({
            open: true,
            iframeUrl: url
        }))
    }
    return { closeOnegamerModal, oneGameModal, openOnegameModal, closeCurrentGameSession }
}


const class_game_activity_select = (state) => state.class_game_activity
export const useClassGameActivity = () => {
    const class_game_activity = useSelector(class_game_activity_select, shallowEqual)
    const currentClass = useCurrentClass();
    const dispatch = useDispatch();
    const fetchClassGameActivity = async () => {
        // dispatch(Actions.clearClassGameActivity());
        await dispatch(handleListClassGameActivity(currentClass.id))
    }
    // useEffect(() => {
    //     if (currentClass && currentClass.id) {
    //         fetchClassGameActivity()
    //     }
    // }, [currentClass])

    return ({
        class_game_activity,
        fetchClassGameActivity
    })
}